import styled from '@emotion/styled';
import { Check as IconCheck, X as IconX } from 'lucide-react';

export const Check = styled(IconCheck)`
  color: ${(p) => p.theme.custom.colors.success.main};
`;

export const Cross = styled(IconX)`
  color: ${(p) => p.theme.custom.colors.error.main};
`;
